const currentYear = new Date().getFullYear();
const range = 5;

const gradYearsArray = Array.from(
  { length: range * 2 + 1 },
  (_, i) => currentYear - range + i
).reverse();

export default gradYearsArray;
